import React, {useState, useEffect, useCallback} from 'react';
import {useLocation} from 'react-router-dom';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {ProgressSpinner} from 'primereact/progressspinner';
import {InputNumber} from 'primereact/inputnumber';
import {
    getActasAdmin,
    getCivilSates, getDocuments,
    getIncapacidadChofer,
    getLicenseTypes,
    getScholarTypes, getStatusList, getTypeActas,
    getUserById, postNuevaActa,
    updateUser, uploadNewFile
} from './integracion';
import {Checkbox} from 'primereact/checkbox';
import {Calendar} from 'primereact/calendar';
import {isoAFechaLocal} from '../../../utilidades/formateos';
import './TestForm.scss';
import {InputTextarea} from "primereact/inputtextarea";
import DocumentTable from "../DocumentModule/DocumentTable";
import TablaIncapacidad from "./TablaIncapacidad";
import TablaActasAdmin from "./TablaActasAdmin";
import Swal from "sweetalert2";
import axios from "axios";
import {uploadImage} from "../../Mantenimiento/UnitsCatalog/Integration";
import {TabPanel, TabView} from "primereact/tabview";
import {Card} from "primereact/card";

const FormularioAltasTest = (usuarioId, onCloseDialog) => {


    const [form, setForm] = useState({
        ID: null,
        ACTIVO: null,
        NOMBRE: "",
        ESTATUS: null,
        DIRECCION: "",
        CODIGO: null,
        COLONIA: "",
        REFERENCIA: "",
        ESTADO: "",
        MUNICIPIO: "",
        CELULAR: "",
        TELEFONO: "",
        CELULAR_PARTICULAR: "",
        TEL_ESPOSA: "",
        INGRESO: null,
        FECHA_BAJA: null,
        FECHA_NACIMIENTO: null,
        RFC: "",
        CURP: "",
        AFILIACION: "",
        TALLA_CAMISA: "",
        TALLA_PANTALON: "",
        ESTADO_CIVIL: null,
        SEXO: null,
        ID_ESCOLARIDAD: null,
        EMAIL: "",
        LONGITUD: null,
        LATITUD: null,
        USUARIO: null,
        CONSUME_DROGAS: null,
        ALTURA: null,
        PESO: null,
        FUMA: null,
        CONSUME_ALCOHOL: null,
        TIPO_SANGRE: null,
        INTERVERCIONES_QUIRURJICAS: false,
        TIPO_INTERVERCIONES_QUIRURJICA: null,
        FRECUENCIA_CARDIACA: null,
        IMC: null,
        TIPO_SANGRE_EMERGENCIA: null,
        GLICEMIA_CAPILAR: null,
        ENTREGA_LICENCIA: null,
        APTO_MEDICO: null,
        ID_NIVEL_HIGIENE: null,
        DIA_DESCANSO: null,
        ID_PUESTO: "",
        ID_PUESTO_GIRO: null,
        NUMERO_LICENCIA: null,
        VENCIMIENTO_LICENCIA: null,
        FOTOGRAFIA: 'https://via.placeholder.com/150',
        RAW_IMAGE: null
    });

    const [statusOptions, setStatusOptions] = useState([])
    const [escolaridadOptions, setEscolaridadOptions] = useState([]);
    const [estadoCivilOptions, setEstadoCivilOptions] = useState([]);
    const [actasOptions, setActasOptions] = useState([]);
    const [licenseOptions, setLicenseOptions] = useState([]);
    const [actasAdmin, setActasAdmin] = useState([]);
    const [docs, setDocs] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [userImage, setUserImage] = useState('https://via.placeholder.com/150');
    const [incapacidadOptions, setIncapacidadOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const estatusOptions = [
        {label: 'Activo', value: 1},
        {label: 'Inactivo', value: 0},
        {label: 'Baja en proceso', value: 2}
    ];

    const higieneOptions = [
        {label: "MUY MALO", value: 1},
        {label: "MALO", value: 2},
        {label: "REGULAR", value: 3},
        {label: "BUENO", value: 4},
        {label: "MUY BUENO", value: 5},
        {label: "EXCELENTE", value: 6}
    ]


    const fetchIncapacidad = async () => {
        try {

            const incapacidaadData = await getIncapacidadChofer(usuarioId.usuarioId);

            setIncapacidadOptions(incapacidaadData);
        } catch (e) {
            console.error('Error fetching incapacidadChofer:', e);
        }
    }

    const fetchActas = async () => {
        try {
            const actasData = await getActasAdmin(form.USUARIO);
            setActasAdmin(actasData);
        } catch (e) {
            console.error('Error fetching actasAdmin:', e);
        }
    }

    const fetchReqDocuments = async () => {

        try {
            const resDocs = await getDocuments()
            setDocs(resDocs)
            console.log("docs", docs)
        } catch (e) {
            console.error('Error fetching documents:', e);
        }
    }

    const fetchTypeActas = async () => {
        try {
            const tipoActas = await getTypeActas()
            setActasOptions(tipoActas);

        } catch (e) {
            console.error('Error fetching actas:', e);
        }
    }


    useEffect(() => {
        const fetchOptions = async () => {
            try {
                // Fetch escolaridad options
                const escolaridadData = await getScholarTypes();
                const formattedEscolaridad = escolaridadData.map(item => ({
                    label: item.ESCOLARIDAD,
                    value: item.ID,
                }));
                setEscolaridadOptions(formattedEscolaridad);

                const licences = await getLicenseTypes();
                const formattedLicences = licences.map(item => ({
                    label: item.TIPO_LICENCIA,
                    value: item.ID
                }))

                setLicenseOptions(formattedLicences);
                // Fetch estado civil options
                const estadoCivilData = await getCivilSates();
                const formattedEstadoCivil = estadoCivilData.map(item => ({
                    label: item.NOMBRE,
                    value: item.ID,
                }));
                setEstadoCivilOptions(formattedEstadoCivil);

            } catch (error) {
                console.error('Error fetching options:', error);
                // Handle error (e.g., show an error message to the user)
            }
        };


        fetchOptions();
    }, []);


    const separationOptions = [
        {label: "MEJOR SUELDO", value: 1},
        {label: "MEJOR EMPLEO", value: 2},
        {label: "INCONFORMIDAD CON DESCUENTOS O PAGOS", value: 3},
        {label: "MEJORES HORARIOS", value: 4},
        {label: "NO ACATAR INDICACIONES DE OPERACIONES", value: 5},
        {label: "ABANDONO DE TRABAJO", value: 6},
        {label: "ROBO DE COMBUSTIBLE", value: 7},
        {label: "RENUNCIA VOLUNTARIA", value: 8},
        {label: "TERMINO DE CONTRATO", value: 9},
        {label: "Separación Voluntaria: Otra oferta laboral", value: 10},
        {label: "Separación Voluntaria: Horario", value: 11},
        {label: "Separación Voluntaria: Clima Laboral", value: 12},
        {label: "Separación Voluntaria: No le gustó el trabajo", value: 13},
        {label: "Separación Voluntaria: Cambio de residencia", value: 14},
        {label: "Separación Voluntaria: Sueldo Garantía", value: 15},
        {label: "Separación Voluntaria: Pensión permanente | Jubilación", value: 16},
        {label: "Separación Voluntaria: Enfermedad Familiar", value: 17},
        {label: "Separación Voluntaria: Jefe Directo", value: 18},
        {label: "Separación Voluntaria: Descuento de Choque", value: 19},
        {label: "Rescisión contrato: Abuso de confianza", value: 20},
        {label: "Rescisión contrato: Positivo dopping/alcoholemia", value: 21},
        {label: "Rescisión contrato: Restructura de Operación", value: 22},
        {label: "Rescisión contrato: Restructura Organizacional", value: 23},
        {label: "Termino de Contrato Evaluación para otorgamiento de planta", value: 24},
        {label: "Defunción Fallecimiento por Enfermedad", value: 25},
        {label: "Defunción Fallecimiento por Accidente", value: 26},
        {label: "Abandono de trabajo", value: 27}
    ];
    const sexoOptions = [
        {label: 'MASCULINO', value: 1},
        {label: 'FEMENINO', value: 2},
        {label: 'N/A', value: 0}
    ];

    const loadUserData = useCallback(async () => {
        if (!usuarioId) {
            resetForm();
            setIsEditing(true); // Se inicia en modo de edición para poder llenar los campos
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const data = await getUserById(usuarioId.usuarioId);

            if (data) {

                const formData = {
                    ID: data.ID || null,
                    ACTIVO: data.ACTIVO,
                    NOMBRE: data.NOMBRE ? data.NOMBRE.trim() : "",
                    DIRECCION: data.DIRECCION ? data.DIRECCION.trim() : "",
                    CODIGO: data.CODIGO ? data.CODIGO.trim() : null,
                    COLONIA: data.COLONIA ? data.COLONIA.trim() : "",
                    REFERENCIA: data.REFERENCIA ? data.REFERENCIA.trim() : "",
                    ESTADO: data.ESTADO ? data.ESTADO.trim() : "",
                    MUNICIPIO: data.MUNICIPIO ? data.MUNICIPIO.trim() : "",
                    CELULAR: data.CELULAR ? data.CELULAR.trim() : "",
                    TELEFONO: data.TELEFONO ? data.TELEFONO.trim() : "",
                    CELULAR_PARTICULAR: data.CELULAR_PARTICULAR ? data.CELULAR_PARTICULAR.trim() : "",
                    TEL_ESPOSA: data.TEL_ESPOSA ? data.TEL_ESPOSA.trim() : "",
                    INGRESO: data.INGRESO ? isoAFechaLocal(data.INGRESO) : null,
                    FECHA_BAJA: data.FECHA_BAJA ? isoAFechaLocal(data.FECHA_BAJA) : null,
                    BAJA: data.BAJA ? data.BAJA : null,
                    FECHA_NACIMIENTO: data.FECHA_NACIMIENTO ? isoAFechaLocal(data.FECHA_NACIMIENTO) : null,
                    RFC: data.RFC ? data.RFC.trim() : "",
                    AFILIACION: data.AFILIACION ? data.AFILIACION.trim() : "",
                    TALLA_CAMISA: data.TALLA_CAMISA ? data.TALLA_CAMISA.trim() : "",
                    TALLA_PANTALON: data.TALLA_PANTALON || null,
                    ESTADO_CIVIL: data.ESTADO_CIVIL ? parseInt(data.ESTADO_CIVIL, 10) : null,
                    SEXO: data.SEXO ? parseInt(data.SEXO, 10) : null,
                    ID_ESCOLARIDAD: data.ID_ESCOLARIDAD ? parseInt(data.ID_ESCOLARIDAD, 10) : null,
                    EMAIL: data.EMAIL ? data.EMAIL.trim() : "",
                    LONGITUD: data.LONGITUD ? parseFloat(data.LONGITUD) : null,
                    LATITUD: data.LATITUD ? parseFloat(data.LATITUD) : null,
                    USUARIO: data.USUARIO || null,
                    ID_NIVEL_HIGIENE: data.ID_NIVEL_HIGIENE || null,
                    CONTACTO_NOMBRE: data.CONTACTO_NOMBRE || "",
                    CONTACTO_TELEFONO: data.CONTACTO_TELEFONO || null,
                    CONSUME_DROGAS: data.CONSUME_DROGAS || null,
                    ALTURA: data.ALTURA || null,
                    PESO: data.PESO || null,
                    FUMA: data.FUMA || null,
                    TIPO_CONSUMO_DROGAS: data.TIPO_CONSUMO_DROGAS || null,
                    CONSUME_ALCOHOL: data.CONSUME_ALCOHOL || null,
                    TIPO_SANGRE: data.TIPO_SANGRE || null,
                    INTERVERCIONES_QUIRURJICAS: data.INTERVERCIONES_QUIRURJICAS || false,
                    TIPO_INTERVERCIONES_QUIRURJICA: data.TIPO_INTERVERCIONES_QUIRURJICA || null,
                    FRECUENCIA_CARDIACA: data.FRECUENCIA_CARDIACA || null,
                    IMC: data.IMC || null,
                    CURP: data.CURP || null,
                    MOTIVO_BAJA: data.MOTIVO_BAJA || null,
                    TIPO_SANGRE_EMERGENCIA: data.TIPO_SANGRE_EMERGENCIA || null,
                    GLICEMIA_CAPILAR: data.GLICEMIA_CAPILAR || null,
                    DIA_DESCANSO: data.DIA_DESCANSO ? isoAFechaLocal(data.DIA_DESCANSO) : null,
                    ID_PUESTO: data.ID_PUESTO || null,
                    ESTATUS: data.ESTATUS || null,
                    TIPO_LICENCIA: data.TIPO_LICENCIA || null,
                    ID_PUESTO_GIRO: data.ID_PUESTO_GIRO ? parseInt(data.ID_PUESTO_GIRO, 10) : null,
                    FOTOGRAFIA: data.FOTOGRAFIA || 'https://via.placeholder.com/150',
                    NUMERO_LICENCIA: data.NUMERO_LICENCIA || null,
                    ENTREGA_LICENCIA: data.ENTREGA_LICENCIA ? isoAFechaLocal(data.ENTREGA_LICENCIA) : null,
                    VENCIMIENTO_LICENCIA: data.VENCIMIENTO_LICENCIA ? isoAFechaLocal(data.VENCIMIENTO_LICENCIA) : null,
                    APTO_MEDICO: data.APTO_MEDICO ? isoAFechaLocal(data.APTO_MEDICO) : null,
                    MEDIDA_PREVENTIVA: data.MEDIDA_PREVENTIVA || null,
                };

                setForm(formData);

                if (data.FOTOGRAFIA) {
                    setUserImage(`${process.env.REACT_APP_EMPLOYEES_IMAGE_URL}/${data.FOTOGRAFIA.trim()}`);
                }
            } else {
                setError("No se encontraron datos para el ID proporcionado.");
                resetForm();
            }
        } catch (err) {
            console.error("Error al cargar los datos del usuario:", err);
            setError("Error al cargar los datos. Por favor, intente de nuevo.");
        } finally {
            setLoading(false);
        }
    }, [usuarioId]);


    async function loadStatusList() {
        const statusList = await getStatusList()
        setStatusOptions(statusList.map(status => ({
            label: status.NOMBRE,
            value: status.ID
        })))
    }

    useEffect(() => {
        loadStatusList()
        fetchReqDocuments()
        if (usuarioId) {
            // Si hay un ID, carga los datos del usuario para edición
            loadUserData();
            // Desactiva el modo de edición inicial para que sea de solo lectura
            fetchIncapacidad()

            fetchTypeActas()
            setIsEditing(false);
        } else {
            // Si no hay ID, entra directamente en modo de alta
            resetForm();
            setIsEditing(true); // Se inicia en modo de edición para poder llenar los campos
            setLoading(false);
        }

    }, [loadUserData, usuarioId]);

    useEffect(() => {
        fetchActas()
    }, [form.USUARIO])
    const resetForm = () => {
        setForm({
            ID: null,
            ACTIVO: null,
            NOMBRE: "",
            ESTATUS: null,
            DIRECCION: "",
            CODIGO: null,
            COLONIA: "",
            REFERENCIA: "",
            ESTADO: "",
            MUNICIPIO: "",
            CELULAR: "",
            TELEFONO: "",
            CELULAR_PARTICULAR: "",
            TEL_ESPOSA: "",
            INGRESO: null,
            FECHA_NACIMIENTO: null,
            RFC: "",
            CURP: "",
            AFILIACION: "",
            TALLA_CAMISA: "",
            TALLA_PANTALON: "",
            ESTADO_CIVIL: null,
            SEXO: null,
            ID_ESCOLARIDAD: null,
            EMAIL: "",
            LONGITUD: null,
            LATITUD: null,
            USUARIO: "",
            DIA_DESCANSO: null,
            ID_PUESTO: "",
            ID_PUESTO_GIRO: null,
            FOTOGRAFIA: 'https://via.placeholder.com/150',
            CONSUME_DROGAS: false, // O null si prefieres
            ALTURA: null,
            PESO: null,
            FUMA: false,
            CONSUME_ALCOHOL: false,
            APTO_MEDICO: false,
            ENTREGA_LICENCIA: null,
            FECHA_BAJA: null,
            IMC: null,
            FRECUENCIA_CARDIACA: null,
            GLICEMIA_CAPILAR: null,
            INTERVERCIONES_QUIRURJICAS: null,
            NUMERO_LICENCIA: null,
            ID_NIVEL_HIGIENE: null,
            VENCIMIENTO_LICENCIA: null,
            TIPO_SANGRE: "",
            TIPO_SANGRE_EMERGENCIA: "",
            TIPO_INTERVERCIONES_QUIRURJICA: ""
        });
        setUserImage('https://via.placeholder.com/150');
    };

    useEffect(() => {
        loadUserData();
    }, [loadUserData]);


    const handleFieldChange = (fieldName, value) => {
        setForm(prevForm => {
            const newForm = {...prevForm, [fieldName]: value};
            return newForm;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const hoy = new Date();
        const isActivating = Number(form.ACTIVO) === 1;
        const isDeactivating = Number(form.ACTIVO) === 0;

        // Aplica reglas al objeto que vas a ENVIAR (no al state original)
        let formWithBusinessRules = { ...form };

        // Si desactiva y no hay FECHA_BAJA -> poner hoy
        if (isDeactivating && !formWithBusinessRules.FECHA_BAJA) {
            formWithBusinessRules.FECHA_BAJA = hoy;
        }

        // Si activa y hay FECHA_BAJA -> enviar null explícito
        if (isActivating && formWithBusinessRules.FECHA_BAJA) {
            formWithBusinessRules.FECHA_BAJA = null;
            formWithBusinessRules.MOTIVO_BAJA = null; // opcional
        }

        // Conversión de tipos usando formWithBusinessRules
        const forceStringFields = new Set([
            'AFILIACION','TALLA_CAMISA','NUMERO_LICENCIA','TELEFONO','TELEFONO_CASA','TELEFONO_CELULAR',
            'CELULAR_PARTICULAR','TEL_ESPOSA','CONTACTO_TELEFONO','CONYUGUE_TELEFONO', 'CELULAR'
        ]);

        const formDataWithCorrectTypes = {};
        for (const key in formWithBusinessRules) {
            if (!Object.prototype.hasOwnProperty.call(formWithBusinessRules, key)) continue;
            const value = formWithBusinessRules[key];

            if (typeof value === 'boolean') {
                formDataWithCorrectTypes[key] = value ? 1 : 0;
            } else if (value instanceof Date) {
                formDataWithCorrectTypes[key] = value.toISOString();
            } else if (forceStringFields.has(key)) {
                formDataWithCorrectTypes[key] = value == null ? '' : String(value).trim();
            } else if (typeof value === 'string' && !isNaN(Number(value)) && value.trim() !== '') {
                formDataWithCorrectTypes[key] = Number(value);
            } else if (value !== undefined) {
                formDataWithCorrectTypes[key] = value === null ? null : value;
            }
        }

        delete formDataWithCorrectTypes.FOTOGRAFIA;

        if (form.RAW_IMAGE instanceof File) {
            const params = new FormData();
            for (const key in formDataWithCorrectTypes) {
                if (!Object.prototype.hasOwnProperty.call(formDataWithCorrectTypes, key) || key === 'RAW_IMAGE') continue;
                const v = formDataWithCorrectTypes[key];
                if (v === null) {

                    params.append(`${key}__isNull`, '1');
                } else {
                    params.append(key, v);
                }
            }
            params.append('FOTOGRAFIA', form.RAW_IMAGE);
            await updateUser(params);
        } else {
            const { RAW_IMAGE, ...dataToSend } = formDataWithCorrectTypes;
            await updateUser(dataToSend);
        }

        setIsEditing(false);
    };
    const handleChangeImage = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setUserImage(reader.result);
                    setForm(prevForm => ({
                        ...prevForm,
                        RAW_IMAGE: file
                    }));
                };
                reader.readAsDataURL(file);

            }
        };
        fileInput.click();
    };

    const renderDoc = (name) => {
        return (
            <div className="div-file-item">
                <i className='pi pi-check-circle'
                   style={{fontSize: '1rem', color: '#007202ff', paddingRight: '20px'}}></i>
                <label>22/09/2025</label>
                <label>{name}</label>
                <i className="pi pi-file-edit"></i>
                <i className="pi pi-pen-to-square"></i>
            </div>
        )
    }

    const renderField = (fieldName, labelText, type = 'text', options = []) => {
        const isNonEditable = ['ID', 'EMAIL', 'LATITUD', 'LONGITUD'].includes(fieldName);
        const fieldValue = form[fieldName];


        // Formatear valor para mostrar cuando no está en edición
        let displayValue = fieldValue;
        if (type === 'date' && fieldValue instanceof Date) {
            displayValue = fieldValue.toLocaleDateString('es-MX');
        } else if (type === 'dropdown' && fieldValue !== null && fieldValue !== undefined) {
            const option = options.find(opt => opt.value === fieldValue);
            displayValue = option ? option.label : String(fieldValue);
        } else if (type === 'cb') {
            displayValue = fieldValue ? (

                <i className='pi pi-check-circle' style={{fontSize: '1rem', color: '#007202ff'}}></i>

            ) : (

                <i className='pi pi-times-circle' style={{fontSize: '1rem', color: '#ff0505ff'}}></i>

            )


        } else if (fieldValue === null || fieldValue === undefined) {
            displayValue = '';
        } else {
            displayValue = String(fieldValue).trim();
        }


        if (isNonEditable || !isEditing) {
            return (
                <div className="data-row-th" key={fieldName}>
                    <label className="field-name-th">{labelText} </label>
                    <label style={{maxWidth: '350px'}}>{displayValue}</label>
                </div>
            );
        }


        // Modo edición
        switch (type) {
            case 'date':

                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>

                        <Calendar value={fieldValue} onChange={(e) => {
                            handleFieldChange(fieldName, e.value)
                        }}> </Calendar>


                    </div>
                );

            case 'dropdown':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <Dropdown
                            value={fieldValue}
                            options={options}
                            onChange={(e) => handleFieldChange(fieldName, e.value)}
                            placeholder={`Seleccionar ${labelText}`}
                            className="p-inputtext-sm"
                            style={{fontSize: '12px'}}
                        />
                    </div>
                );

            case 'number':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputNumber
                            value={fieldValue}
                            onValueChange={(e) => handleFieldChange(fieldName, e.value)}
                            mode="decimal"
                            useGrouping={false}
                            className="p-inputtext-sm"
                            style={{fontSize: '12px'}}
                        />
                    </div>
                );

            case 'short-number':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText}</label>
                        <InputNumber
                            value={fieldValue}
                            onValueChange={(e) => handleFieldChange(fieldName, e.value)}
                            mode="decimal" // Or 'none' if you don't need decimals/grouping
                            useGrouping={false} // Usually good for short numbers

                            className="p-inputtext-sm"

                        />
                    </div>
                );
            case 'cb':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <Checkbox
                            checked={fieldValue || false}
                            onChange={(e) => handleFieldChange(fieldName, e.checked)}
                            className="p-checkbox-sm"/>

                    </div>
                );
            case 'long-text':
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputTextarea
                            value={fieldValue || ''}
                            onChange={(e) => handleFieldChange(fieldName, e.target.value)}
                            autoResize
                            rows={3}
                            className='my-large-input p-inputtext-sm'
                        />
                    </div>
                );
            case 'text':
            default:
                return (
                    <div className="data-row-th" key={fieldName}>
                        <label className="field-name-th">{labelText} </label>
                        <InputText
                            value={fieldValue || ''}
                            onChange={(e) => handleFieldChange(fieldName, e.target.value)}

                            className='my-large-input p-inputtext-sm'
                        />

                    </div>
                );
        }
    };

    const handleSaveActa = async (payload) => {

        try {
            const acta = {
                ID: payload.ID ?? undefined,
                NOMBRE: payload.NOMBRE,
                NUM_ACTA: payload.NUM_ACTA,
                ID_ACTA: payload.ID_ACTA,
                MOTIVO: payload.MOTIVO,
                ID_USUARIO: form.USUARIO || 0,
                FECHA_ACTA: payload.FECHA_ACTA,
            };

            const ok = await postNuevaActa(acta);

            if (ok) {
                await Swal.fire({
                    icon: "success",
                    title: "Acta guardada",
                    text: "El acta se registró correctamente.",
                    timer: 1800,
                    showConfirmButton: false
                });
                await fetchActas();
            } else {
                await Swal.fire({
                    icon: "error",
                    title: "No se pudo guardar",
                    text: "El servidor no confirmó el guardado.",
                });
            }
        } catch (e) {
            await Swal.fire({
                icon: "error",
                title: "Error al guardar",
                text: e?.response?.data?.message || "Ocurrió un error inesperado.",
            });
            console.error("Error guardando acta:", e);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-content-center align-items-center" style={{height: '300px'}}>
                <ProgressSpinner/>
                <p>Cargando datos del usuario...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-message p-message-error" style={{margin: '20px'}}>
                <div className="p-message-text">{error}</div>
                <p>Por favor, asegúrate de que el ID sea válido o intenta de nuevo.</p>
            </div>
        );
    }

    const uploadFile = async ({documento, file}) => {
        if (!file) return;
        const userId = form?.USUARIO || form?.ID; // elige el campo correcto de tu estado
        const fd = new FormData();
        fd.append("userId", userId);
        fd.append("documento", documento?.documento); // nombre/tipo del doc si lo necesitas en backend
        fd.append("file", file);

        // Ejemplo: llama a tu integración
        try {
            await uploadNewFile(fd); // o tu función axios.post(...)
            // opcional: toast o refrescar lista
        } catch (e) {

        }
    }
    const isInactive = Number(form.ACTIVO) === 0;

    return (
        <div className="table-personal-th">
            <div className="user-profile-layout-final">
                {/* ENCABEZADO PRINCIPAL CON DATOS Y BOTONES DE ACCIÓN */}
                <div className="profile-header">
                    <img src={userImage} alt="Foto de perfil" className="header-image"/>
                    {isEditing && (
                        <Button
                            label=""
                            icon="pi pi-upload"
                            className="change-image-button"
                            style={{marginRight: '10px'}}
                            onClick={handleChangeImage}
                        />
                    )}
                    <div className="header-info">
                        <h2 className="header-name">{form.NOMBRE || 'Nuevo Operador'}</h2>
                        <div className="header-meta">
                            <span><strong>ID:</strong> {form.ID || 'N/A'}</span>
                            <span><b>Usuario:</b> {renderField('USUARIO', '', 'short-number')}</span>
                        </div>
                    </div>
                    {/* ACCIONES AHORA ESTÁN AQUÍ */}
                    <div className="header-actions">

                        {!isEditing && (
                            <Button
                                label="Editar"
                                icon="pi pi-pencil"
                                style={{marginRight: '10px', backgroundColor: '#ff6400', borderColor: '#ff6400'}}
                                onClick={() => setIsEditing(true)}
                            />
                        )}
                        {isEditing && (
                            <div className="editing-actions">
                                <Button label="Guardar" icon="pi pi-save" className="p-button-success"
                                        onClick={handleSubmit}/>
                                {usuarioId && (
                                    <Button
                                        label="Cancelar"
                                        icon="pi pi-times"
                                        style={{
                                            marginRight: '10px',
                                            marginLeft: '10px',
                                            backgroundColor: '#ff1010',
                                            borderColor: '#9e0000'
                                        }}
                                        onClick={() => {
                                            setIsEditing(false);
                                            loadUserData();
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* PESTAÑAS CON TODA LA INFORMACIÓN */}
                <div className="tabs-container">
                    <TabView>
                        <TabPanel header="Información">
                            <div className="info-cards-container">
                                {/* TARJETA DE DATOS PERSONALES */}
                                <Card
                                    title={<div className="card-title-container"><i className="pi pi-user mr-2"/><span>Datos Personales y de Contacto</span>
                                    </div>}>
                                    <div className="form-grid">
                                        {renderField('NOMBRE', 'Nombre Completo')}
                                        {renderField('FECHA_NACIMIENTO', 'F. Nacimiento', 'date')}
                                        {renderField('RFC', 'RFC')}
                                        {renderField('CURP', 'CURP')}
                                        {renderField('SEXO', 'Sexo', 'dropdown', sexoOptions)}
                                        {renderField('DIRECCION', 'Dirección')}
                                        {renderField('COLONIA', 'Colonia')}
                                        {renderField('CODIGO', 'C.P.', 'number')}
                                        {renderField('MUNICIPIO', 'Municipio')}
                                        {renderField('ESTADO', 'Estado')}
                                        {renderField('CELULAR', 'Celular SUMA', 'number')}
                                        {renderField('CELULAR_PARTICULAR', 'Celular Particular', 'number')}
                                        {renderField('TEL_ESPOSA', 'Tel. Esposa', 'number')}
                                        {renderField('EMAIL', 'Email')}
                                    </div>
                                </Card>

                                {/* TARJETA DE INFORMACIÓN LABORAL */}
                                <Card title={<div className="card-title-container"><i className="pi pi-briefcase mr-2"/><span>Información Laboral</span>
                                </div>}>
                                    <div className="form-grid">
                                        {renderField('ACTIVO', 'Activo', 'cb')}
                                        {renderField('ESTATUS', 'Estatus', 'dropdown', statusOptions)}
                                        {isInactive && renderField('FECHA_BAJA', 'Fecha Baja', 'date')}
                                        {isInactive && renderField('MOTIVO_BAJA', 'Motivo de Baja', 'dropdown', separationOptions)}
                                        {isInactive && renderField('BAJA', 'Baja (Comentarios)')}
                                        {renderField('INGRESO', 'Fecha Ingreso', 'date')}
                                        {renderField('ID_PUESTO', 'Puesto')}
                                        {renderField('AFILIACION', 'Afiliación IMSS')}
                                        {renderField('ID_ESCOLARIDAD', 'Escolaridad', 'dropdown', escolaridadOptions)}
                                        {renderField('ESTADO_CIVIL', 'Estado Civil', 'dropdown', estadoCivilOptions)}
                                    </div>
                                </Card>

                                {/* TARJETA DE SALUD Y EMERGENCIA */}
                                <Card title={<div className="card-title-container"><i
                                    className="pi pi-heart-fill mr-2"/><span>Salud y Emergencia</span></div>}>
                                    <div className="form-grid">
                                        {renderField('ALTURA', 'Altura (m)', 'number')}
                                        {renderField('PESO', 'Peso (kg)', 'number')}
                                        {renderField('IMC', 'IMC', 'number')}
                                        {renderField('TIPO_SANGRE', 'Tipo Sangre')}
                                        {renderField('FRECUENCIA_CARDIACA', 'Frecuencia Cardiaca', 'number')}
                                        {renderField('GLICEMIA_CAPILAR', 'Glicemia Capilar', 'number')}
                                        {renderField('FUMA', 'Fuma', 'cb')}
                                        {renderField('CONSUME_ALCOHOL', 'Consume Alcohol', 'cb')}
                                        {renderField('CONSUME_DROGAS', 'Consume Drogas', 'cb')}
                                        {renderField('TIPO_CONSUMO_DROGAS', 'Tipo de Drogas')}
                                        {renderField('INTERVERCIONES_QUIRURJICAS', 'Intervenciones Quirúrgicas', 'cb')}
                                        {renderField('TIPO_INTERVERCIONES_QUIRURJICA', 'Tipo de Intervenciones')}
                                        {renderField('CONTACTO_NOMBRE', 'Nombre (Emergencia)')}
                                        {renderField('CONTACTO_TELEFONO', 'Teléfono (Emergencia)', 'number')}
                                        {renderField('TIPO_SANGRE_EMERGENCIA', 'Tipo Sangre (Emergencia)')}
                                    </div>
                                </Card>

                                {/* TARJETA DE LICENCIA */}
                                <Card title={<div className="card-title-container"><i
                                    className="pi pi-id-card mr-2"/><span>Información de Licencia</span></div>}>
                                    <div className="form-grid">
                                        {renderField('NUMERO_LICENCIA', 'Número Licencia')}
                                        {renderField('TIPO_LICENCIA', 'Tipo Licencia', 'dropdown', licenseOptions)}
                                        {renderField('ENTREGA_LICENCIA', 'Entrega Licencia', 'date')}
                                        {renderField('VENCIMIENTO_LICENCIA', 'Vencimiento', 'date')}
                                        {renderField('APTO_MEDICO', 'Vig. Apto Médico', 'date')}
                                        {renderField('MEDIDA_PREVENTIVA', 'Med. Preventiva', 'number')}
                                    </div>
                                </Card>
                            </div>
                        </TabPanel>

                        {/* OTRAS PESTAÑAS */}
                        <TabPanel header="Documentos">
                            <DocumentTable reqDocuments={docs} onApply={uploadFile} nombre={form?.NOMBRE}/>
                        </TabPanel>
                        <TabPanel header="Incapacidades">
                            <TablaIncapacidad data={incapacidadOptions} userName={form?.NOMBRE} choferId={form?.ID}/>
                        </TabPanel>
                        <TabPanel header="Actas Administrativas">
                            <TablaActasAdmin data={actasAdmin} onSave={handleSaveActa} options={actasOptions}
                                             chofer={form} fetchActas={fetchActas}/>
                        </TabPanel>
                    </TabView>
                </div>
            </div>
        </div>
    );
};

export default FormularioAltasTest;